/* =============================================================
   Plek in Bloei — zoeken
   Overlay met suggesties via Shopify's predictive search.
   ============================================================= */

(function (PIB) {
  'use strict';

  PIB.register('zoeken', function (root) {
    var laag = root.querySelector('#zoeklaag') || document.getElementById('zoeklaag');
    if (!laag || !PIB.eenmalig(laag, 'zoekGebonden')) return;

    var veld = laag.querySelector('input[type="search"]');
    var uitvoer = laag.querySelector('[data-zoekuitvoer]');
    var start = laag.querySelector('[data-zoekstart]');
    if (!veld || !uitvoer) return;

    var wacht;
    var lopend;

    function zoek(term) {
      if (lopend) lopend.abort();
      lopend = new AbortController();

      var url = '/search/suggest'
        + '?q=' + encodeURIComponent(term)
        + '&resources[type]=product,collection,article'
        + '&resources[limit]=6'
        + '&section_id=predictive-search';

      fetch(url, { signal: lopend.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tijdelijk = document.createElement('div');
          tijdelijk.innerHTML = html;
          var inhoud = tijdelijk.querySelector('[data-zoekresultaat]');
          uitvoer.innerHTML = inhoud ? inhoud.innerHTML : '';
          if (start) start.hidden = true;
        })
        .catch(function () { /* afgebroken of offline: laat staan wat er staat */ });
    }

    veld.addEventListener('input', function () {
      clearTimeout(wacht);
      var term = veld.value.trim();

      if (term.length < 2) {
        uitvoer.innerHTML = '';
        if (start) start.hidden = false;
        return;
      }

      wacht = setTimeout(function () { zoek(term); }, 220);
    });

    laag.querySelectorAll('[data-zoekterm]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        veld.value = knop.dataset.zoekterm;
        veld.focus();
        zoek(knop.dataset.zoekterm);
      });
    });
  });
})(window.PIB);
